import { render, staticRenderFns } from "./AppSubMenuWithTeams.vue?vue&type=template&id=48f66dfc&lang=pug&"
import script from "./AppSubMenuWithTeams.vue?vue&type=script&lang=js&"
export * from "./AppSubMenuWithTeams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports